import React, { useState, useEffect } from 'react';
import Layout from '@/components/Layout';
import { ArrowLeft } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function TestingCompsReadyPage() {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSections();
  }, []);

  const loadSections = async () => {
    try {
      const response = await axios.get(`${API}/test-categories/comps_ready`);
      setSections(response.data);
    } catch (error) {
      console.error('Failed to load sections:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSectionClick = (sectionSlug) => {
    window.location.href = `/testing-center/comps-ready/${sectionSlug}`;
  };

  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-b from-[#F4E4C1] to-[#E8D5B7] py-16">
        <div className="max-w-5xl mx-auto px-4">
          {/* Header */}
          <div className="flex items-center justify-between mb-8">
            <button
              onClick={() => window.location.href = '/testing-center'}
              className="retro-button flex items-center gap-2"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Testing Center
            </button>
          </div>

          <h1 className="text-5xl md:text-6xl retro-title mb-4 text-center">Comps Ready</h1>
          <p className="text-xl text-center text-[#6B4423] mb-12">25-question timed tests • Comprehensive coverage • Board exam prep</p>

          {/* Sections Grid */}
          {loading ? (
            <div className="text-center py-12">
              <div className="w-16 h-16 border-4 border-[#D4A574] border-t-transparent rounded-full animate-spin mx-auto"></div>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {sections.map((section) => (
                <button
                  key={section.id}
                  onClick={() => handleSectionClick(section.slug)}
                  className="cassette-card p-6 text-left hover:shadow-xl transition-shadow cursor-pointer"
                >
                  <div className="flex items-start gap-4">
                    <div className="text-5xl">{section.icon}</div>
                    <div className="flex-1">
                      <h3 className="text-2xl retro-title text-[#2C1810] mb-2">{section.name}</h3>
                      <p className="text-[#6B4423]">{section.description}</p>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
